/**
 * Single source of truth for React Query / tRPC query key prefixes.
 * Use these instead of inline arrays to prevent key mismatches.
 *
 * tRPC v11 query keys follow the pattern: [['router', 'procedure'], { input, type }]
 * These prefixes enable partial matching for invalidation/refetch.
 */
export const queryKeys = {
  // Top-level prefixes (match all sub-procedures)
  messages: [['messages']] as const,
  // Specific procedure keys
  messagesList: [['messages', 'list']] as const,
  channels: [['channels']] as const,
  channelsList: [['channels', 'list']] as const,
  assistantConversations: [['assistantConversations']] as const,
  // `files` stays: the engine's rendered deliverables are files, and resetting a
  // run invalidates them. The listAll/memory keys went with the Files and Brain
  // pages that were their only consumers.
  files: [['files']] as const,
  requirements: [['requirements']] as const,
  projects: [['projects']] as const,
  playground: [['playground']] as const,
  agentTestSuggestions: [['agentBench', 'listTestSuggestions']] as const,
  agentExpectations: [['agentBench', 'listExpectations']] as const,
  agentCase: [['agentBench', 'getCase']] as const,
  agentCases: [['agentBench', 'listCases']] as const,
  agentRuns: [['agentBench', 'listPromptRuns']] as const,
  agentComparison: [['agentBench', 'getPromptComparison']] as const,
  agentRun: [['agentBench', 'getTrial']] as const,
  agentFeedback: [['agentBench', 'getFeedback']] as const,
  agentRunFeedback: [['agentBench', 'getRunFeedback']] as const,
  agentReviews: [['agentBench', 'listRunReviews']] as const,
  agentSharedReview: [['agentBench', 'getSharedReview']] as const,
} as const;
